






























































































  import { defineComponent, ref, computed, onMounted, PropType } from 'vue'
  import { Products } from '@one/types'
  import { Cart, Wishlist } from '@one/types/dist/orderpath/app'
  import uuid from 'uuid-random'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import { useCompareStore } from '~/stores/useCompareStore'

  export interface ProductQuantityAndResourceId {
    id?: string
    quantity: number
  }

  export interface WishlistInterface {
    id: string
    name: string
    timestamp: number
  }

  export default defineComponent({
    name: 'OneProductTileRightActions',
    props: {
      productId: {
        type: String,
        required: true,
      },
      unit: {
        type: String,
        required: true,
      },
      carts: {
        type: Array as PropType<Array<Cart.Responses.BasicCartInfo>>,
        required: true,
      },
      wishlists: {
        type: Array as PropType<Array<Wishlist.Responses.BasicWishlist>>,
        required: true,
      },
      showAddToWishlistButton: {
        type: Boolean,
        default: true,
      },
      showAddToCompareButton: {
        type: Boolean,
        default: true,
      },
      progress: {
        type: Boolean,
        default: false,
      },
      progressWishlist: {
        type: Boolean,
        default: false,
      },
      extended: {
        type: Boolean,
        default: true,
      },
    },
    setup(props, { emit }) {
      const vm = useCurrentInstance()
      const compareStore = useCompareStore()

      const btnWishlistId = `btn-wishlist-${uuid()}`
      const btnCartId = `btn-add-cart-${uuid()}`

      const quantityInOrderUnit = ref<number>(1)
      const calculatedQuantity = ref<number>(0)
      const currentQuantity = ref<number>(1)
      const hasQuantityError = ref<boolean>(false)

      const isCompareEnabled = computed(() => vm.$store.getters['cms/configuration']?.showCompareProducts)
      const product = computed<Products.Product | null>(() => {
        return vm.$store.getters['products/getProduct'](props.productId)
      })
      const isEnoughProductWithBlockLabelInStock = computed(() => {
        return vm.$store.getters['stocks/isEnoughProductWithBlockLabelInStock']
      })
      const disabledAddToCart = computed<boolean>(() => {
        if (!product.value) return false
        return isEnoughProductWithBlockLabelInStock.value(
          currentQuantity.value,
          product.value.labels,
          product.value.id,
        )
      })
      const enabledCalculation = computed<boolean>(() => {
        return !!(
          product.value?.measurementUnits?.contentUnitDescription &&
          product.value?.measurementUnits?.packingQuantity &&
          product.value?.labels?.includes('tile_calculator')
        )
      })

      const isCompared = computed(() => compareStore.isInCompare(props.productId))

      onMounted(() => {
        quantityInOrderUnit.value = product.value?.measurementUnits?.quantityMin ?? 1
        currentQuantity.value = product.value?.measurementUnits?.quantityMin ?? 1
      })

      const changeValue = (event: number) => {
        const absValue = Math.abs(event)
        quantityInOrderUnit.value = absValue
        currentQuantity.value = absValue
        emit('quantity-changed', absValue)
      }

      const onContentQuantityChanged = (event: number) => {
        const packingQuantity = product.value?.measurementUnits?.packingQuantity
        if (packingQuantity) {
          calculatedQuantity.value = Math.ceil(event / packingQuantity)
        }
      }

      const onQuantityError = (e: boolean) => {
        hasQuantityError.value = e
      }

      const addToCart = (id?: string) => {
        if (!hasQuantityError.value) {
          emit('add-to-cart', {
            id,
            quantity: currentQuantity.value,
          })
        }
      }

      const onAddToWishlist = (wishlist?: WishlistInterface) => {
        if (!hasQuantityError.value) {
          emit('add-to-wishlist', {
            wishlist,
            id: wishlist?.id,
            quantity: currentQuantity.value,
          })
        }
      }

      const onToggleCompare = () => {
        if (product.value) {
          compareStore.toggleCompare(product.value)
        }
      }

      return {
        btnWishlistId,
        btnCartId,
        quantityInOrderUnit,
        isCompareEnabled,
        calculatedQuantity,
        currentQuantity,
        hasQuantityError,
        product,
        disabledAddToCart,
        enabledCalculation,
        isCompared,
        onToggleCompare,
        changeValue,
        onContentQuantityChanged,
        onQuantityError,
        addToCart,
        onAddToWishlist,
      }
    },
  })
